module.exports = __webpack_public_path__ + "static/media/icon_nav_user_active.0f0069b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_nav_user_active.svg
// module id = 629
// module chunks = 0